import { ConfigContext } from 'contexts/ConfigContext';
import { useContext } from 'react';
import { CustomizationProps } from 'types/config';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useConfig = (): CustomizationProps => useContext(ConfigContext);

export default useConfig;
